import Vue from 'vue';
import Vuex from 'vuex';
import { Store } from 'vuex';
import { dashboard } from '../modules/neodash/store/modules/dashboard';
import { filters } from '../modules/neodash/store/modules/filters';
import { report } from '../modules/neodash/store/modules/report';
import { actions } from './actions';
import { getters } from './getters';
import Logger from './logger';
import { authentication } from './modules/authentication';
import { notifications } from './modules/notifications';
import { print } from './modules/print';
import { settings } from './modules/settings';
import { mutations } from './mutations';
import { state } from './state';
import {reports} from '../modules/neodash/store/modules/reports';

const debug = false; // process.env.NODE_ENV !== 'production';

Vue.use(Vuex);

export const store = new Store({
  actions,
  getters,
  modules: {
    [authentication.name]: authentication,
    [dashboard.name]: dashboard,
    [filters.name]: filters,
    [notifications.name]: notifications,
    [print.name]: print,
    [report.name]: report,
    [settings.name]: settings,
    [reports.name]: reports
  },
  mutations,
  plugins: debug ? [Logger()] : [],
  state,
  strict: debug,
});
